// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__ZDXcN","pageCounter":"Pagination_pageCounter__1AlaZ","icon":"Pagination_icon__WZ_Xs"};